import React from 'react';

import { connect } from 'react-redux';

import { NumStepper } from '@nerdwallet/react-stepper';

import { AMORTIZATION } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/amortization-calculator-selector';
import {
  AmortizationInput,
  formatYears,
  inputOnChange,
} from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const LoanTermInput: React.FC<AmortizationInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
}) => {
  // if inputType is RANGE we need to set a default value, so taking placeholder if needed
  const placeholder = inputs?.loanTerm;
  const value = manualInputs?.loanTerm ?? placeholder;
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: onInputChange) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'loanTerm',
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'loanTerm',
      calculator: AMORTIZATION,
      inputType: 'number',
    });
  };

  return (
    <NumStepper
      editable
      formatter={formatYears}
      max={30}
      min={1}
      stepSize={1}
      value={value}
      onChange={onInputChange}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanTermInput);
